import { createContext, useContext, useMemo } from "react";
import PropTypes from "prop-types";
import { useOutletContext } from "react-router-dom";
import usePagePagination from "../hooks/usePagePagination";

const PageContext = createContext(null);

// Page context = pagination state/counts (from spec.shell.pagination) + module-supplied pageData.
// A page whose data hook needs page/pageSize up front calls usePagePagination itself and passes
// the instance as `pagination`; otherwise the provider owns it.
export function RewampPageProvider({ spec, pageData, pagination: external, children }) {
  const own = usePagePagination(external ? null : spec?.shell?.pagination);
  const pagination = external ?? own;
  const value = useMemo(() => ({ ...pageData, pagination }), [pageData, pagination]);
  return <PageContext.Provider value={value}>{typeof children === "function" ? children(value) : children}</PageContext.Provider>;
}

RewampPageProvider.propTypes = {
  spec: PropTypes.shape({ shell: PropTypes.object }),
  pageData: PropTypes.object,
  pagination: PropTypes.object,
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.func]),
};

RewampPageProvider.defaultProps = { spec: null, pageData: {}, pagination: null, children: null };

// Falls back to the router outlet context so tab children migrate one at a time.
export function usePageContext() {
  const page = useContext(PageContext);
  const outlet = useOutletContext();
  return page ?? outlet ?? {};
}
